import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { ValidateMessages } from 'rc-field-form/lib/interface';
import { devWarning } from '../../wui-core/src/warning'; // import { ModalLocale, changeConfirmLocale } from '../modal/locale';
// import { TransferLocale as TransferLocaleForEmpty } from '../empty';
// import { PaginationLocale } from '../pagination/Pagination';
// import { TableLocale } from '../table/interface';
// import { PopconfirmLocale } from '../popconfirm';
// import { UploadLocale } from '../upload/interface';
// import { TransferLocale } from '../transfer';
// import { PickerLocale as DatePickerLocale } from '../date-picker/generatePicker';

import LocaleContext from './locale-context';
export var ANT_MARK = 'internalMark'; // export interface Locale {
//   locale: string;
//   Pagination?: PaginationLocale;
//   DatePicker?: DatePickerLocale;
//   TimePicker?: Object;
//   Calendar?: Object;
//   Table?: TableLocale;
//   Modal?: ModalLocale;
//   Popconfirm?: PopconfirmLocale;
//   Transfer?: Partial<TransferLocale>;
//   Select?: Object;
//   Upload?: UploadLocale;
//   Empty?: TransferLocaleForEmpty;
//   global?: Object;
//   PageHeader?: Object;
//   Icon?: Object;
//   Text?: Object;
//   Form?: {
//     optional?: string;
//     defaultValidateMessages: ValidateMessages;
//   };
//   Image?: {
//     preview: string;
//   };
// }

export var Locale = {
  locale: "zh-CN"
}; // export interface LocaleProviderProps {
//   locale: Locale;
//   children?: React.ReactNode;
//   _ANT_MARK__?: string;
// }

var LocaleProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(LocaleProvider, _React$Component);

  var _super = _createSuper(LocaleProvider);

  // TODO:// modal机制需要了解一下，暂时不处理Modal中confirm中changeConfirmLocale
  function LocaleProvider(props) {
    var _this;

    _classCallCheck(this, LocaleProvider);

    _this = _super.call(this, props); // changeConfirmLocale(props.locale && props.locale.Modal);

    devWarning(props._ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead');
    return _this;
  }

  _createClass(LocaleProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {// changeConfirmLocale(this.props.locale && this.props.locale.Modal);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var locale = this.props.locale;

      if (prevProps.locale !== locale) {// changeConfirmLocale(locale && locale.Modal);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {// changeConfirmLocale();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          locale = _this$props.locale,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement(LocaleContext.Provider, {
        value: _objectSpread(_objectSpread({}, locale), {}, {
          exist: true
        })
      }, children);
    }
  }]);

  return LocaleProvider;
}(React.Component);

_defineProperty(LocaleProvider, "defaultProps", {
  locale: {}
});

export { LocaleProvider as default };


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-locale/src/locale-provider.js